import type { Event } from '@patsnap/tahiti-core';
import type { NoveltyCheckTaskStep } from '../enums';
import type { NoveltyCheckTaskStatus } from '../types';

/**
 * 获取任务状态服务
 * @description 获取任务状态, 并更新任务状态模型 {@link NoveltyCheckTaskStatusModel}
 */
export interface NoveltyCheckTaskStatusService {
    /**
     * 服务端任务步骤
     */
    readonly serverSideTaskStep: NoveltyCheckTaskStep;
    /**
     * 服务端任务步骤事件
     */
    readonly onServerSideTaskStep: Event<NoveltyCheckTaskStep>;
    /**
     * 获取任务状态, 并更新任务状态模型 {@link NoveltyCheckTaskStatusModel}
     */
    pullTaskStatus(): Promise<NoveltyCheckTaskStatus>;
}

export const NoveltyCheckTaskStatusService = Symbol('NoveltyCheckTaskStatusService');
